import { colors } from '../../../theme'
import { body2, headline2, label1, quote1 } from '../../../theme/typography'

export const HERO_IMAGE = require('../../../../assets/images/onboarding-hero_v2.jpg')

export const INTRO_HEADLINE_STYLE = { ...quote1, color: '#000' }
export const INTRO_BODY_STYLE = { ...body2, color: '#000' }
export const INTRO_LABEL_STYLE = { ...label1, color: '#000' }

export const PANEL_HEADER_STYLE = { ...headline2, color: colors.ink }
export const PANEL_BODY_STYLE = { ...body2, color: colors.ink }
export const PANEL_BODY_SECONDARY_STYLE = {
  ...body2,
  color: colors.inkSecondary,
}
export const PANEL_LABEL_STYLE = { ...label1, color: colors.ink }
export const PANEL_LABEL_CTA_STYLE = {
  ...label1,
  color: colors.primaryForeground,
}

export const INTRO_GRADIENT_COLORS = [
  'rgba(255, 255, 255, 0)',
  'rgba(255, 255, 255, 1)',
] as const

export const INTRO_GRADIENT_LOCATIONS = [0, 1] as const
